var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('wrapper',{staticClass:"wrapper",attrs:{"backgroundImage":_vm.configuratorData.CityMap ? _vm.configuratorData.CityMap.url : ''}},[_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }